import {
  Component,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { DxDataGridComponent, DxTemplateDirective, DxTemplateModule } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import notify from 'devextreme/ui/notify';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-grid-storico-consegne-articolo-dipendente',
  templateUrl: './grid-storico-consegne-articolo-dipendente.component.html',
  styleUrls: ['./grid-storico-consegne-articolo-dipendente.component.scss'],
  imports: [
    DxDataGridComponent,
    DxoLookupComponent,
    DxiColumnComponent,
    DxoExportComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoExportComponent,
    DxoHeaderFilterComponent,
    DxoFilterRowComponent,
    DxoExportComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxTemplateModule
  ],
})
export class GridStoricoConsegneArticoloDipendenteComponent
  extends GestArticoliBaseComponent
  implements OnInit, OnChanges
{
  private movService = inject(MovimentoArticoliService);
  private articoliService = inject(ArticoliService);
  private artMatService = inject(ArticoliMatricolaService);
  @Input() idDipendente: number;
  @Input() idArticolo: number;

  dataSource: any;
  columnResizingMode = 'widget';

  gestMatricole: boolean;

  listArticoli: any;
  listArticoliMatricola: any;

  constructor() {
    super();
    this.gestMatricole = this.isModVisible('Matricole');
  }

  ngOnInit() {
    this.loadLookUp();
  }

  ngOnChanges(changes: SimpleChanges) {
    const dipendenteChanged =
      changes['idDipendente'] &&
      changes['idDipendente'].currentValue !==
        changes['idDipendente'].previousValue;

    const articoloChanged =
      changes['idArticolo'] &&
      changes['idArticolo'].currentValue !==
        changes['idArticolo'].previousValue;

    if (
      this.idDipendente &&
      dipendenteChanged &&
      this.idArticolo &&
      articoloChanged
    ) {
      this.loadMovimentiArticoli();
    }
  }

  loadLookUp() {
    //Articoli
    this.articoliService.listTemp().subscribe({
      next: (res) => {
        this.listArticoli = {
          store: {
            type: 'array',
            data: res.filter(x => x.attivo == true).sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1)),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      }
    });

    //MAtricole
    if (this.gestMatricole) {
      this.artMatService.list().subscribe({
        next: (res) => {
          this.listArticoliMatricola = {
            store: {
              type: 'array',
              data: res.sort((a, b) => (a.matricola < b.matricola ? -1 : 1)),
              key: 'id',
            },
            pageSize: 10,
            paginate: true,
          };
        },
        error: (error) => {
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore caricamento articoli matricola', 'warning');
          }
        },
      });
    }
  }

  loadMovimentiArticoli() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(
          this.movService.filtered(this.idArticolo, this.idDipendente, 0),
        )
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
    });
  }
}
